import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAv_xGYpTqi0Nuf7FNxlm5b6VPLd65AzwY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "elemental-7e5d9.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "elemental-7e5d9",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "elemental-7e5d9.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "27215474250",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:27215474250:web:fb11015a06711334fb80b3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

export default app;
